export default "__VITE_ASSET__CXsOcLPG__"